import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ContactSection from "../../components/common/ContactSection";
import BiospecimenHero from "./BiospecimenHero";
import ProcurementOptions from "../../components/common/ProcurementOptions";
import { Check } from "lucide-react";
import SampleAccountability from "../../components/common/SampleAccountability";
import {
  Database,
  Bell,
  FileText,
  ShieldCheck,
  QrCode,
  Siren,
} from "lucide-react";

const Biostorage = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const customData2 = [
    {
      title: "Prospective Collections:",
      description:
        "Custom-designed specimen collection following your specific protocol.",
    },
    {
      title: "Rare Cohorts:",
      description:
        "Hard-to-find patient populations and uncommon disease states",
    },
    {
      title: "Matched Specimen Sets:",
      description:
        "Tumor/normal pairs, pre/post-treatment series, longitudinal collections",
    },
    {
      title: "Sample Handling",
      description:
        "Precision sample processing, aliquoting, and secure storage solutions.",
    },
    {
      title: "Multi-Matrix Collections:",
      description: "Multiple specimen types from the same subjects",
    },
    {
      title: "Custom Data Capture:",
      description:
        "Comprehensive clinical datasets integrated across all sample workflows.",
    },
  ];
  const accountabilityData = [
    {
      icon: QrCode,
      title: "Digital Inventory Management",
      description:
        "Unique barcode identifiers track exact storage location, freeze-thaw cycles, and handling events.",
    },
    {
      icon: Siren,
      title: "24/7 Environmental Monitoring",
      description:
        "Automated sensors record data with real-time alerts for any temperature deviations.",
    },
    {
      icon: FileText,
      title: "Comprehensive Documentation",
      description:
        "Detailed logs for every sample movement and personnel interaction, available upon request.",
    },
    {
      icon: ShieldCheck,
      title: "Redundancy & Backup Systems",
      description:
        "Emergency generators and backup freezers ensure zero sample loss incidents.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />
        <BiospecimenHero />
        <ProcurementOptions
          title="What We Can Deliver"
          descriptionTitle="Every ANVIYA biospecimen meets stringent quality and ethical standards:"
          options={customData2}
          icon={Check} // Optional: Changes the icon for all cards
        />
        {/* <SampleAccountability /> */}
        <SampleAccountability
          title="Our Laboratory Standards"
          features={accountabilityData}
          imageSrc="/images/BiostorageImg/AccountabilityImg.png"
        />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default Biostorage;
